import { Injectable } from '@angular/core';
import { environment } from '@env/environment.prod';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  private key = CryptoJS.enc.Base64.parse(environment.encryptKey);
  private iv = CryptoJS.enc.Base64.parse('#base64IV#');

  constructor() { }

  encrypt(req: string, password?: boolean) {
    // Encrypt the Password
    // Man in the Middle Secure v1

    // const encrypteds = CryptoJS.AES.encrypt(str, key, {
    //   iv: iv
    // });

    // Save the Login in to an array
    // const secureUsercreds = {
    //   username: usercreds.username,
    //   password: encrypteds.toString()
    // };

    // const creds = `name=${secureUsercreds.username}&password=${
    //   secureUsercreds.password
    // }`;
    if (!req) return req;

    let encrypted;

    req = req.toString();
    if (password) {
      encrypted = CryptoJS.AES.encrypt(req, this.key, {
        iv: this.iv
      });
    } else {
      encrypted = CryptoJS.AES.encrypt(req, environment.encryptKey);
    }

    let encryptedmessage = encrypted.toString();
    if (!password) {
      encryptedmessage = encryptedmessage
        .replace(/\+/g, 'aFaFa')
        .replace(/\//g, 'bFbFb')
        .replace(/=+$/, 'cFcFc');
    }
    return encryptedmessage;
  }

  /** Decrypt Request and return the decode value */
  decrypt(req: string, password?: boolean) {
    if (!req) return req;

    if (!password) {
      req = req
        .replace(/aFaFa/g, '+')
        .replace(/bFbFb/g, '/')
        .replace(/cFcFc/g, '=');
    }
    const a = req.toString().replace(' ', '+');
    const b = a.replace(' ', '+');
    // Decrypt Message
    // const key = CryptoJS.enc.Base64.parse(environment.encryptKey);
    // const iv = CryptoJS.enc.Base64.parse('#base64IV#');

    let decrypted;

    if (password) {
      decrypted = CryptoJS.AES.decrypt(b, this.key, {
        iv: this.iv
      });
    } else {
      decrypted = CryptoJS.AES.decrypt(b, environment.encryptKey);
    }
    const c = decrypted.toString(CryptoJS.enc.Utf8);

    // // Convert to Object
    // const d = '{"' + c.replace('="', ':') + '"}';
    // const e = d.replace('&', '","');

    // // Replace Prams to OBJ
    // const f = e.replace('password=', 'password":"');
    // const g = f.replace('name=', 'name":"');
    // const h = g.toString();
    // let OBJ = '';
    // try {
    //   OBJ = JSON.parse(h);
    // } catch (err) {
    //   this.decrypt(req);
    // }

    // Return
    return c;
  }

  encryptPwd(data: string) {
    if (!data) return data;
    const iv = CryptoJS.enc.Base64.parse('');
    const encrypted = CryptoJS.AES.encrypt(data, this.key, { iv: iv });
    return encrypted.toString();
  }

  decryptPwd(data: string) {
    if (!data) return data;
    const decrypted = CryptoJS.AES.decrypt(data, this.key, {
      iv: CryptoJS.enc.Base64.parse('')
    });
    let value = "";
    try {
      value = decrypted.toString(CryptoJS.enc.Utf8);
    }
    catch (Exception) {
      console.warn("Decrypt", Exception);
    }
    return value;
  }
}